import get from 'lodash/get'
import isArray from 'lodash/isArray'
import alertActions from 'optinmonster-js-library/src/vue/campaigns/store/alerts/actions'
import { getAppData, siteId } from '@/utils'

export default {
	...alertActions,
	fetchMe ({ state, commit, dispatch, getters }, { loading = null } = {}) {
		if (null === loading) {
			loading = !getters.connected
		}

		if (loading) {
			commit('loading', 'me')
		}

		return new Promise((resolve, reject) => {
			if (!state.apiKey) {
				commit('doneLoading', 'me')
				return resolve()
			}
			return this._vm.$api
				.get('me?includeOnboarding=true')
				.then(({ body }) => {
					commit('setUser', body)
					commit('doneLoading', 'me')

					const types = get(body, 'campaignTypes')
					if (types && isArray(types)) {
						commit('templates/permittedTypes', types)
					}

					dispatch('notifications/fetch')
					if ('onboarding-wizard' !== get(state, 'route.name')) {
						dispatch('wizard/complete', null, { root: true })
					}

					this._vm.$bus.$emit('fetchedMe')
					resolve()
				})
				.catch(error => {
					commit('setError', error)
					commit('doneLoading', 'me')
					reject(error)
					console.error({ error })
				})
		})
	},
	saveApiKey ({ commit, dispatch }, key) {
		commit('loading', 'connect')
		return new Promise((resolve, reject) => {
			const handleError = (error) => {
				this._vm.$bus.$emit('saveApiKeyFailed', key)
				commit('closeAlerts', null)

				error.explanation = '<strong>Something went wrong while attempting to connect</strong>'
				commit('setError', error)
				commit('doneLoading', 'connect')
				reject(error)
				console.error({ error })
			}

			const success = ({ body }) => {
				this._vm.$bus.$emit('saveApiKeySuccess', key, body)
				commit('doneLoading', 'connect')

				resolve()
			}

			commit('setApiKey', key)

			return this._vm.$api
				.post({ wpEndpoint: 'omapp/v1/api/' })
				.send({ key })
				.then(success)
				.catch(handleError)
		})
	},
	disconnect ({ commit, dispatch }) {
		commit('loading', 'disconnect')
		return new Promise((resolve, reject) => {
			const handleError = (error) => {
				commit('closeAlerts', null)

				error.explanation = '<strong>Something went wrong while attempting to disconnect</strong>'
				commit('setError', error)
				commit('doneLoading', 'disconnect')
				reject(error)
				console.error({ error })
			}

			const success = () => {
				this._vm.$bus.$emit('disconnectSuccess')
				commit('setApiKey', '')
				commit('resetUser')
				dispatch('wizard/resetState')
				commit('doneLoading', 'disconnect')
				resolve()
			}

			return this._vm.$api
				.delete({ wpEndpoint: 'omapp/v1/api/' })
				.then(success)
				.catch(handleError)
		})
	},
	triggerSiteUpdateVerification ({ commit, getters }) {
		return new Promise((resolve, reject) => {
			if (!getters.connected) {
				return resolve()
			}

			let endpoint = `sites/${siteId}/update-verification`
			endpoint += `?site_url=${encodeURIComponent(this._vm.$urls.wp())}`
			endpoint += `&rest_url=${encodeURIComponent(this._vm.$urls.wpRest())}`

			return this._vm.$api
				.get({ endpoint, cached: false })
				.then(({ body }) => {
					resolve(body)
				})
				.catch(error => {
					error.explanation = 'Site update verification failed.'
					error.closes = true
					commit('setError', error)
					reject(error)
					console.error({ error })
				})
		})
	},
	setTitle ({ commit }, { title, setBannerTitle = true }) {
		document.title = getAppData('titleTag', title).replace('{replaceme}', title)

		if (setBannerTitle) {
			commit('setBannerTitle', title)
		}
	},
}
